import { render } from "./OAuthButtons.vue?vue&type=template&id=016b7e36&scoped=true"
import script from "./OAuthButtons.vue?vue&type=script&lang=js"
export * from "./OAuthButtons.vue?vue&type=script&lang=js"

import "./OAuthButtons.vue?vue&type=style&index=0&id=016b7e36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-016b7e36"]])

export default __exports__